<template>
  <div class="pa-10">
    <h1 class="display-1 text-center mb-8">Covid Test</h1>

    <form class="personal-info d-flex flex-column" @submit.prevent="submit">
      <div class="subtitle-1 font-weight-bold mb-2">
        1. {{ $t("cellexTest.first.firstTitle") }}
      </div>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.firstNameLabel') + '*'"
        v-model="firstName"
        :error-messages="
          $v.$dirty && !$v.firstName.required ? 'This field is required' : null
        "
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.lastNameLabel') + '*'"
        v-model="lastName"
        :error-messages="
          $v.$dirty && !$v.lastName.required ? 'This field is required' : null
        "
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.idNumberLabel') + '*'"
        v-model="idNumber"
        :error-messages="
          $v.$dirty && !$v.idNumber.required ? 'This field is required' : null
        "
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.orgCode') + '*'"
        :error-messages="orgCodeErrors"
        v-model="orgCode"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.emailLabel') + '*'"
        v-model="email"
        :error-messages="emailErrors"
      ></v-text-field>

      <v-radio-group
        v-model="gender"
        column
        dense
        :label="$t('cellexTest.first.genderLabel')"
        class="align-self-start"
      >
        <v-radio
          :label="$t('cellexTest.first.male')"
          value="male"
          color="primary"
          :ripple="false"
        ></v-radio>
        <v-radio
          :label="$t('cellexTest.first.female')"
          value="female"
          color="primary"
          :ripple="false"
        ></v-radio>
      </v-radio-group>

      <v-menu
        ref="menu"
        v-model="menu"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="birthDateFormatted"
            :label="$t('cellexTest.first.birthDateLabel')"
            prepend-icon="mdi-calendar"
            class="flex-grow-0"
            v-on="on"
            readonly
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="birthDate"
          no-title
          color="primary"
        ></v-date-picker>
      </v-menu>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.countryLabel')"
        v-model="country"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.nationalityLabel')"
        v-model="nationality"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.cityLabel')"
        v-model="city"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.addressLabel')"
        v-model="address"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.postalCodeLabel')"
        v-model="postalCode"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.first.phoneLabel')"
        v-model="phone"
      ></v-text-field>

      <div class="d-flex align-center align-self-center">
        <!-- <v-btn color="primary" depressed class="ml-2" @click="submitPersonal">
          ΑΠΟΘΗΚΕΥΣΗ
        </v-btn> -->
        <v-btn color="primary" depressed class="ml-2"  @click="submitPersonal">{{
          $t("cellexTest.first.btn")
        }}</v-btn>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import moment from "moment";

const validFunc = function () {
  return !this.validOrgCode;
};

export default {
  mixins: [validationMixin],
  data() {
    return {
      firstName: "",
      lastName: "",
      companyExists: [],
      validOrgCode: false,
      idNumber: "",
      orgCode: "",
      gender: "male",
      menu: false,
      birthDate: null,
      country: "",
      nationality: "",
      city: "",
      address: "",
      postalCode: "",
      phone: "",
      email: "",
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    idNumber: { required },
    orgCode: { validFunc },
    email: { required, email },
  },
  computed: {
    ...mapState({
      newSelfServiceCellexTest: (state) => state.selfService.newSelfServiceCellexTest,
    }),
    birthDateFormatted() {
      if (!this.birthDate) return "";
      return moment(this.birthDate).format("DD/MM/YYYY");
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("This field is required");
      if (!this.$v.email.email)
        errors.push("Please enter a valid email format.");
      return errors;
    },
    orgCodeErrors(){
      const errors = []
      if(!this.$v.orgCode.$dirty) return errors
      if(!this.$v.orgCode.validFunc) errors.push('Wrong code')
      return errors
    }
  },
  created() {
    this.firstName = this.newSelfServiceCellexTest?.personalInfo?.firstName;
    this.lastName = this.newSelfServiceCellexTest?.personalInfo?.lastName;
    this.idNumber = this.newSelfServiceCellexTest?.personalInfo?.idNumber;
    this.orgCode = this.newSelfServiceCellexTest?.personalInfo?.orgCode;
    this.gender = this.newSelfServiceCellexTest?.personalInfo?.gender
      ? this.newSelfServiceCellexTest.personalInfo.gender
      : "male";
    this.birthDate = this.newSelfServiceCellexTest.personalInfo?.birthDate
      ? moment(this.newSelfServiceCellexTest.personalInfo?.birthDate).toISOString()
      : null;
    this.country = this.newSelfServiceCellexTest?.personalInfo?.country;
    this.nationality = this.newSelfServiceCellexTest?.personalInfo?.nationality;
    this.city = this.newSelfServiceCellexTest?.personalInfo?.city;
    this.address = this.newSelfServiceCellexTest?.personalInfo?.address;
    this.postalCode = this.newSelfServiceCellexTest?.personalInfo?.postalCode;
    this.phone = this.newSelfServiceCellexTest?.personalInfo?.phone;
    this.email = this.newSelfServiceCellexTest?.personalInfo?.email;
  },
  methods: {
    ...mapActions(["newSelfServiceCellexTestFirst", "newSelfServiceCellexTestPersonal"]),
    submit() {
      this.$v.$touch();
      console.log(this.companyExists);
      if (this.$v.$invalid) return;

      this.newSelfServiceCellexTestFirst({
        firstName: this.firstName,
        lastName: this.lastName,
        idNumber: this.idNumber,
        orgCode: this.orgCode,
        gender: this.gender,
        birthDate: moment(this.birthDate).toDate(),
        country: this.country,
        nationality: this.nationality,
        city: this.city,
        address: this.address,
        postalCode: this.postalCode,
        phone: this.phone,
        email: this.email,
      });
    },
    submitPersonal() {
      this.$v.$touch();
      if (this.$v.$invalid && this.companyExists.length > 0) return;

      this.newSelfServiceCellexTestPersonal({
        firstName: this.firstName,
        lastName: this.lastName,
        idNumber: this.idNumber,
        orgCode: this.orgCode,
        gender: this.gender,
        birthDate: moment(this.birthDate).toDate(),
        country: this.country,
        nationality: this.nationality,
        city: this.city,
        address: this.address,
        postalCode: this.postalCode,
        phone: this.phone,
        email: this.email,
      });
    },
  },

  watch: {
    orgCode(val) {
      if (!!val) {
        axios
          .get(`${process.env.VUE_APP_BASE_URL}/org/valid/${val}`)
          .then((res) => {
            console.log(res);
            if (!res.data) {
              // this.companyExists.push("Not valid");
              this.validOrgCode = true;
            } else {
              this.validOrgCode = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }else{
        this.validOrgCode = false;
        this.orgCode = null
        this.$v.orgCode.$reset()
      }
    },
  },
};
</script>